import axios from 'axios'
import jwt from 'jsonwebtoken'
import store from '@/store'

const axiosInstance = axios.create()

if (process.env.NODE_ENV === 'development') {
  axiosInstance.defaults.baseURL = 'http://localhost:5000'
}

axiosInstance.interceptors.request.use(async config => {
  const isLoggedIn = store.getters.isLoggedIn

  if (!isLoggedIn)
    return config

  const { exp } = jwt.decode(store.getters.accessToken)

  if (!exp || exp - 5 <= (Date.now() / 1000))
    await store.dispatch('refreshAccessToken')

  config.headers.authorization = `Bearer ${store.getters.accessToken}`

  return config
})

export default {
  getUsers({ year, sortBy, sortOrder }) {
    return axiosInstance.get('/api/admin/users', {
      params: {
        year,
        sortBy,
        sortOrder,
      },
    })
      .then(response => response.data)
  },

  updateUsersHasFiledTaxForm(userId, flag) {
    return axiosInstance.put(`/api/admin/users/${userId}/hasFiledTaxForm/${flag}`)
      .then(response => response.data)
  },

  getVoucherCodes({ sortBy, sortOrder }) {
    return axiosInstance.get('/api/admin/voucherCodes', {
      params: {
        sortBy,
        sortOrder,
      },
    })
      .then(response => response.data)
  },

  createVoucherCodes(data) {
    return axiosInstance.post('/api/admin/voucherCodes', data)
      .then(response => response.data)
  },

  exportVoucherCodes({ extension }) {
    return axiosInstance.post(`/api/admin/voucherCodes/export`, {
      extension,
    }, {
      responseType: 'blob',
    })
      .then(response => {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {
          type,
          encoding: 'UTF-8',
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `voucher-codes-${Date.now()}.${extension}`)
        link.click()

        return response.data
      })
  },

  signOut() {
    return axiosInstance.delete('/api/auth')
      .then(response => response.data)
  },
}
